"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SqFt = function SqFt(_ref) {
  var size = _ref.size,
      color = _ref.color,
      rest = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    width: size,
    height: size,
    fill: color,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52"
  }, rest), _react.default.createElement("path", {
    d: "M7.5 40a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v35a1 1 0 0 1-1 1z"
  }), _react.default.createElement("path", {
    d: "M11.5 9a.997.997 0 0 1-.707-.293L7.494 5.409l-3.293 3.24A1 1 0 0 1 2.8 7.223l4-3.936a1 1 0 0 1 1.408.006l4 4A1 1 0 0 1 11.5 9zM7.5 40a.997.997 0 0 1-.707-.293l-4-4a1 1 0 1 1 1.414-1.414l3.299 3.298 3.293-3.24a1 1 0 1 1 1.402 1.425l-4 3.937A.997.997 0 0 1 7.5 40zM48.5 45h-35a1 1 0 1 1 0-2h35a1 1 0 1 1 0 2z"
  }), _react.default.createElement("path", {
    d: "M44.5 49a1 1 0 0 1-.707-1.707l3.299-3.299-3.241-3.292a1 1 0 0 1 1.425-1.404l3.937 4a1 1 0 0 1-.006 1.409l-4 4A.997.997 0 0 1 44.5 49zM17.437 49a.998.998 0 0 1-.713-.298l-3.937-4a1 1 0 0 1 .006-1.409l4-4a1 1 0 1 1 1.414 1.414l-3.299 3.299 3.241 3.292A1 1 0 0 1 17.437 49zM47.5 37h-32a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h32a1 1 0 0 1 1 1v32a1 1 0 0 1-1 1zm-31-2h30V5h-30v30z"
  }), _react.default.createElement("path", {
    d: "M27.5 14h-12a1 1 0 1 1 0-2h12a1 1 0 1 1 0 2zM47.5 14h-12a1 1 0 1 1 0-2h12a1 1 0 1 1 0 2zM31.5 14a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v9a1 1 0 0 1-1 1zM30.5 33h-11a1 1 0 0 1-1-1V21a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1zm-10-2h9v-9h-9v9z"
  }));
};

SqFt.displayName = "SqFt";
SqFt.defaultProps = {
  size: 24,
  color: "currentColor"
};
var _default = SqFt;
exports.default = _default;